// extracted by mini-css-extract-plugin
module.exports = {"link-container":"Landing_link-container__2mGfu"};